import { createAction, props } from '@ngrx/store';

export const globalErrorWasThrown = createAction('[Error] Global error was thrown', props<{ message?: string }>());
